import { render } from "./Xbox.vue?vue&type=template&id=38ce27e6"
import script from "./Xbox.vue?vue&type=script&lang=js"
export * from "./Xbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__